import React from 'react';
import Switch from 'react-switch';

import Modal from '../../components/Modal';
import { romanize } from '../../utils';

const ChapterNamingSidebar = ({ applySettings = () => {}, hasCustomChapterNames = false }) => {
    const [prefix, setPrefix] = React.useState('Chapter');
    const [separator, setSeparator] = React.useState('');
    const [numberType, setNumberType] = React.useState('Normal');
    const [hasCustomNames, setHasCustomNames] = React.useState(hasCustomChapterNames || false);
    const [isWarningModalVisible, setIsWarningModalVisible] = React.useState(false);

    const applyNamingSettings = () => {
        setIsWarningModalVisible(false);

        applySettings({
            prefix,
            separator,
            numberType,
            hasCustomNames
        });
    };

    const handleCustomNamesSwitch = (nextChecked) => {
        if (!nextChecked) {
            setSeparator('');
        }
        setHasCustomNames(nextChecked);
    };

    const getExampleString = () => {
        let num = numberType === 'Roman' ? romanize(4) : 1;
        let str = `${prefix} ${num}`;

        if (hasCustomNames) {
            str = `${str} ${separator === 'Space' ? ' ' : separator} Custom Name`;
        }

        return str;
    };

    return (
        <div className="afm-naming-sidebar">
            <div className="afm-naming-sidebar-section">
                <div className="font-weight-bold mb-3">Chapter Auto Naming</div>
                <div className="font-italic mb-4">Example: {getExampleString()}</div>
                <div className="mb-4">
                    <label className="afm-react-switch-wrap">
                        <Switch
                            onChange={handleCustomNamesSwitch}
                            checked={hasCustomNames}
                            className="afm-react-switch"
                            uncheckedIcon={false}
                            checkedIcon={false}
                        />
                        <span style={{ lineHeight: '28px' }}>This book has custom chapter names.</span>
                    </label>
                </div>
                <div className="row">
                    <div className="col-xs-1">1.</div>
                    <div className="col-xs-11">
                        <div className="mb-2">Prefix</div>
                        <select
                            id="prefix"
                            className="custom-select form-control"
                            value={prefix}
                            onChange={(e) => setPrefix(e.target.value)}
                        >
                            <option value="Chapter">Chapter</option>
                            <option value="Stanza">Stanza</option>
                            <option value="Capitulo">Capitulo</option>
                            <option value="Act">Act</option>
                            <option value="Section">Section</option>
                            <option value="Topic">Topic</option>
                            <option value="Lesson">Lesson</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="afm-naming-sidebar-section">
                <div className="row">
                    <div className="col-xs-1">2.</div>
                    <div className="col-xs-11">
                        <div className="mb-2">Number</div>
                        <select
                            id="numberType"
                            className="custom-select form-control"
                            value={numberType}
                            onChange={(e) => setNumberType(e.target.value)}
                        >
                            <option value="Normal">Integer (1, 2,...)</option>
                            <option value="Roman">Roman Numeral (I, II, ..)</option>
                        </select>
                    </div>
                </div>
            </div>
            {hasCustomNames && (
                <div className="afm-naming-sidebar-section" style={{ borderBottom: '0 none' }}>
                    <div className="row">
                        <div className="col-xs-1">3.</div>
                        <div className="col-xs-11">
                            <div className="mb-2">Separator</div>
                            <select
                                id="separator"
                                className="custom-select form-control"
                                value={separator}
                                onChange={(e) => setSeparator(e.target.value)}
                            >
                                <option value="">None</option>
                                <option value="-">Hyphen</option>
                                <option value=":">Colon</option>
                                <option value="Space">Space</option>
                            </select>
                        </div>
                    </div>
                </div>
            )}
            <div className="row" style={{ padding: '20px' }}>
                <div className="col-xs-12">
                    <button className="btn btn-success" onClick={() => setIsWarningModalVisible(true)}>
                        Apply Changes
                    </button>
                </div>
            </div>

            <Modal
                label="Auto Naming Warning"
                visible={isWarningModalVisible}
                onClose={() => setIsWarningModalVisible(false)}
                innerClassName="modal-s text-center"
            >
                <div>
                    <h4>Auto Naming Warning</h4>
                    <div className="mb-3">
                        <small>
                            Continuing will overwrite all of your existing track names and you will not be able to undo
                            this. Manually editing each track name will still be available.
                        </small>
                    </div>
                    <div>
                        <button className="btn btn-success" onClick={applyNamingSettings}>
                            Ok, Apply Changes
                        </button>
                        <button className="btn" onClick={() => setIsWarningModalVisible(false)}>
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ChapterNamingSidebar;
